function validate(token) {
    return fetch("https://recaptchaenterprise.googleapis.com/v1/projects/fotlyft-v3-1737219985158/assessments?key=AIzaSyClJsZja0iQYPxSwIdp7nCvHcB2n_oXNCg", {
        method: "POST",
        body: JSON.stringify({
            "event": {
                "token": token,
                "siteKey": "6Lfd8wEsAAAAAHZYT6h4Q4oeUO8mZhbMiR8MQcnn"
            }
        }),
        headers: { "Content-type": "application/json; charset=UTF-8" }
    })
    .then(response => response.json())
    .then(data => {
        const isValid = data.tokenProperties && data.tokenProperties.valid;
        const score = data.riskAnalysis ? data.riskAnalysis.score : 0;
        
        console.log("reCAPTCHA Bedömning klar. Score:", score);

        // Vi sätter gränsen till 0.3. 
        // Om isValid är sant och poängen är 0.3 eller högre returneras true.
        if (isValid && score >= 0.6) {
            return true;
        } else {
            return false;
        }
    })
    .catch(err => {
        console.error("Fel vid verifiering:", err);
        return false;
    });
}

/**
 * Huvudfunktion för att köra verifieringen
 */
function runVerification() {
    if (sessionStorage.getItem('recaptcha_passed')) return;

    grecaptcha.ready(function() {
        grecaptcha.execute('6Lfd8wEsAAAAAHZYT6h4Q4oeUO8mZhbMiR8MQcnn', {action: 'submit'})
            .then(function(token) {
                validate(token).then(isHuman => {
                    const buyButton = document.querySelector('[name="add"]'); // Hittar din Köp-knapp
                    
                    if (isHuman) {
                        console.log("reCAPTCHA: Människa bekräftad.");
                        sessionStorage.setItem('recaptcha_passed', 'true');
                        // Om knappen varit låst, lås upp den
                        if(buyButton) buyButton.style.opacity = "1";
                        if(buyButton) buyButton.style.pointerEvents = "auto";
                    } else {
                        // Om poängen är för låg (bot), gör knappen oklickbar och blek
                        console.warn("reCAPTCHA: Misstänkt bot. Begränsar åtkomst.");
                        if(buyButton) {
                            buyButton.style.opacity = "0.5";
                            buyButton.style.pointerEvents = "none"; // Gör att den inte går att klicka på
                            buyButton.title = "Verifiering misslyckades. Ladda om sidan.";
                        }
                    }
                });
            });
    });
}

// Starta verifieringen 3 sekunder efter att reCAPTCHA är redo.
// Fördröjningen gör att poängen (score) oftast blir högre då användaren hunnit interagera lite.
grecaptcha.ready(function() {
    setTimeout(runVerification, 1200);
});